"use client";

import { instantMeiliSearch } from "@meilisearch/instant-meilisearch";

const HOST = process.env.NEXT_PUBLIC_MEILISEARCH_URL;
const API_KEY = process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY;

const cache: { client: ReturnType<typeof instantMeiliSearch> | null } = {
  client: null,
};

/**
 * Returns a stable singleton Meilisearch client.
 * Creating a new client on each call would cause InstantSearch to reinitialise
 * (resetting accumulated infinite-scroll hits) every time the parent component
 * re-renders.
 */
export const meilisearchClient = () => {
  if (!HOST || !API_KEY) {
    throw new Error("MeiliSearch host or API key not found");
  }
  if (!cache.client) {
    cache.client = instantMeiliSearch(HOST, API_KEY);
  }
  return cache.client;
};
